import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectIcon16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMediaObjectIcon16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 3H3a1 1 0 0 0-.347.062L5.5 7.128l2.847-4.066A1 1 0 0 0 8 3m.993.882L6.11 8l2.883 4.118Q9 12.06 9 12V4q0-.06-.007-.118M4.89 8 2.007 3.882A1 1 0 0 0 2 4v8q0 .06.007.118zm-2.237 4.938L5.5 8.872l2.847 4.066A1 1 0 0 1 8 13H3a1 1 0 0 1-.347-.062M3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm9 2a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5 3.5A.5.5 0 0 1 12 7h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectIcon16);
